/**
 * External dependencies.
 */
import { useRouter } from "next/router";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import { t } from "@lingui/macro";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import classNames from "classnames";

/**
 * Internal dependencies.
 */
import Field from "components/field/field";
import IconArrowLarge from "../../assets/images/svg/icon-arrow-large.svg";
import IconSearch from "../../assets/images/svg/icon-search.svg";

interface FormTopicSearchProp {
  search?: string;
  locale?: string;
}

const schema = yup
  .object()
  .shape({
    search: yup.string().required(),
  })
  .required();

const FormTopicSearch: React.FC<FormTopicSearchProp> = ({ search, locale }) => {
  const router = useRouter();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormTopicSearchProp>({
    mode: "onChange",
    defaultValues: {
      search: search || "",
    },
    resolver: yupResolver(schema),
  });
  const onSubmit: SubmitHandler<FormTopicSearchProp> = (data) => {
    router.push(`/${locale}/search?q=${data.search}`);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="form-topic-search">
      <IconSearch className="icon-search" />
      <Controller
        name="search"
        control={control}
        render={({ field }) => (
          <Field
            onChange={field.onChange}
            placeholder={t`Search for a keyword or topic`}
            type="text"
            value={field.value || ""}
            className={classNames("field--white", { error: errors.search })}
          />
        )}
      />

      <button
        type="submit"
        aria-label="button"
        className="form-topic-search__btn"
      >
        <IconArrowLarge />
      </button>
    </form>
  );
};

export default FormTopicSearch;
